import {
  createStore as reduxCreateStore,
  combineReducers,
  applyMiddleware,
} from "redux";

import { connectRouter, routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";

import { LoadingReducer } from "../loading/reducers";
import { UsersReducer } from "../users/reducers";
import { ProductsReducer } from "../products/reducers";
import { CategoriesReducer } from "../categories/reducers";
import { ShopsReducer } from "../shops/reducers";
import { MakersReducer } from "../makers/reducers";
import { SearchKeywordsReducer } from "../searchKeywords/reducers";
import { BasesReducer } from "../base/reducers";
import { DeparmentsReducer } from "../department/reducers";

export default function createStore(history) {
  return reduxCreateStore(
    combineReducers({
      categories: CategoriesReducer,
      loading: LoadingReducer,
      products: ProductsReducer,
      router: connectRouter(history),
      shops: ShopsReducer,
      bases: BasesReducer,
      departments: DeparmentsReducer,
      makers: MakersReducer,
      users: UsersReducer,
      searchKeywords: SearchKeywordsReducer,
    }),
    applyMiddleware(routerMiddleware(history), thunk)
  );
}
